module.exports = __webpack_public_path__ + "img/oval_selected.198cd086.svg";